/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyDto } from './companyDto';
import { ClientLoyaltyProgramDto } from './clientLoyaltyProgramDto';


export interface ClientNotificationDto { 
    id?: number;
    title?: string;
    message?: string;
    details?: string;
    image?: string;
    company?: CompanyDto;
    loyaltyProgram?: ClientLoyaltyProgramDto;
    type?: ClientNotificationDto.TypeEnum;
    couponId?: number;
    couponName?: string;
    couponImage?: string;
    transactionId?: number;
    transactionKind?: ClientNotificationDto.TransactionKindEnum;
    announcementId?: number;
    announcementImage?: string;
    announcementDetails?: string;
    announcementActive?: boolean;
    announcementValidUntil?: string;
    promotionId?: number;
    pointsAmount?: number;
    loyaltyStatus?: ClientNotificationDto.LoyaltyStatusEnum;
}
export namespace ClientNotificationDto {
    export type TypeEnum = 'IN_TRANSACTION' | 'OUT_TRANSACTION' | 'MANUAL_TRANSACTION' | 'LOYALTY_STATUS_CHANGE' | 'ANNOUNCEMENT' | 'CUSTOM' | 'APP_VERSION' | 'ACCEPTED_TRANSACTION' | 'DECLINED_TRANSACTION' | 'DAILY_LIMIT' | 'CLIENT_AWARDED' | 'GIFT' | 'PROMOTION' | 'COUPON_REDEEMED';
    export const TypeEnum = {
        InTransaction: 'IN_TRANSACTION' as TypeEnum,
        OutTransaction: 'OUT_TRANSACTION' as TypeEnum,
        ManualTransaction: 'MANUAL_TRANSACTION' as TypeEnum,
        LoyaltyStatusChange: 'LOYALTY_STATUS_CHANGE' as TypeEnum,
        Announcement: 'ANNOUNCEMENT' as TypeEnum,
        Custom: 'CUSTOM' as TypeEnum,
        AppVersion: 'APP_VERSION' as TypeEnum,
        AcceptedTransaction: 'ACCEPTED_TRANSACTION' as TypeEnum,
        DeclinedTransaction: 'DECLINED_TRANSACTION' as TypeEnum,
        DailyLimit: 'DAILY_LIMIT' as TypeEnum,
        ClientAwarded: 'CLIENT_AWARDED' as TypeEnum,
        Gift: 'GIFT' as TypeEnum,
        Promotion: 'PROMOTION' as TypeEnum,
        CouponRedeemed: 'COUPON_REDEEMED' as TypeEnum
    };
    export type TransactionKindEnum = 'INVOICE_SCAN' | 'COUPON_BOUGHT' | 'MANUAL_TRANSACTION';
    export const TransactionKindEnum = {
        InvoiceScan: 'INVOICE_SCAN' as TransactionKindEnum,
        CouponBought: 'COUPON_BOUGHT' as TransactionKindEnum,
        ManualTransaction: 'MANUAL_TRANSACTION' as TransactionKindEnum
    };
    export type LoyaltyStatusEnum = 'ACTIVE' | 'BLOCKED';
    export const LoyaltyStatusEnum = {
        Active: 'ACTIVE' as LoyaltyStatusEnum,
        Blocked: 'BLOCKED' as LoyaltyStatusEnum
    };
}


